"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*@ngInject*/
exports.default = ['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('card', {
            url: '/card',
            template: require('../views/card.html'),
            controller: 'CardController',
            controllerAs: 'card'
        })
            .state('card-mobile', {
            url: '/card/mobile',
            template: require('../views/card-mobile.html'),
            controller: 'CardMobileController',
            controllerAs: 'cardMobile'
        });
    }];



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/card/config/routes.js
// module id = 461
// module chunks = 0